<template>
  <div class="message">
    <div class="info_box">
      <div class="fliter">
        <!-- <div class="fliter_item">
          <el-button type="primary" icon="Plus" @click="addTransaction">新增项目</el-button>
        </div> -->
        <div class="fliter_item" style="width: 200px">
          <el-input v-model="paginationData.projectNo" placeholder="请输入项目编号" style="width: 200px" clearable>
          </el-input>
        </div>
        <div class="fliter_item" style="width: 200px">
          <el-input v-model="paginationData.projectName" placeholder="请输入项目名称" style="width: 200px" clearable>
          </el-input>
        </div>
        <div class="fliter_item">
          <el-button type="primary" icon="Search" @click="searchData">检索</el-button>
        </div>
        <div class="fliter_item">
          <el-button plain icon="RefreshLeft" @click="resetData">重置</el-button>
        </div>
      </div>
      <el-table ref="multipleTable" :data="tableData" stripe border v-loading="loading">
        <el-table-column type="index" label="序号" width="80"></el-table-column>
        <el-table-column prop="bidName" label="中标人"></el-table-column>
        <el-table-column prop="bidPrice" label="中标价格"></el-table-column>
        <el-table-column prop="projectName" label="中标项目名称"></el-table-column>
        <el-table-column prop="projectNo" label="中标项目编号"></el-table-column>
        <el-table-column prop="updateTime" label="中标时间"></el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="200px"
        >
          <template #default="scope">
<!--            <el-link type="primary" @click="dataDetail(scope.$index, scope.row)">查看详情</el-link>-->
<!--            <el-divider direction="vertical"></el-divider>-->
            <el-link type="primary" v-if="scope.row.status == '6'"
                     @click="getReList(scope.$index, scope.row)">转租</el-link>
            <el-divider direction="vertical"></el-divider>
            <el-link type="primary" v-if="scope.row.status == '6' || scope.row.status == '4' "
                     @click="getContractDetail(scope.$index, scope.row)">查看合同</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrap flex_end">
        <el-pagination background :current-page="paginationData.pageNum" :page-size.sync="paginationData.pageSize"
          @current-change="handleCurrentChange" layout="total, prev, pager, next"
          :total="paginationData.total"></el-pagination>
      </div>
    </div>
    <el-drawer v-model="contractPopup" title="合同详情" direction="rtl">
      <el-descriptions class="margin-top" :column="1" :size="size" border v-if="contractInfo.xhProjectFileList">
        <el-descriptions-item>
          <template #label>
            <div class="cell-item">
              项目编号
            </div>
          </template>
          {{ contractInfo.projectNo }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            <div class="cell-item">
              项目名称
            </div>
          </template>
          {{ contractInfo.projectName }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            <div class="cell-item">
              合同编号
            </div>
          </template>
          {{ contractInfo.contractNo }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            <div class="cell-item">
              合同金额（元）
            </div>
          </template>
          {{ contractInfo.price }}
        </el-descriptions-item>

        <el-descriptions-item>
          <template #label>
            <div class="cell-item">
              合同开始年限
            </div>
          </template>
          {{ contractInfo.startDate }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            <div class="cell-item">
              合同结束年限
            </div>
          </template>
          {{ contractInfo.endDate }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            <div class="cell-item">
              合同签订时间
            </div>
          </template>
          {{ contractInfo.contractDealDate }}
        </el-descriptions-item>
        <div v-if="contractInfo.xhProjectFileList.length > 0">
          <el-descriptions-item>
            <template #label>
              <div class="cell-item">
                附件列表
              </div>
            </template>
            <el-link v-for="(item, index) in contractInfo.xhProjectFileList" :key="index" :href="item.filePath"
                     target="_blank">{{ item.fileName }}, </el-link>
            <!-- {{ item.filePath }} -->
          </el-descriptions-item>
        </div>

      </el-descriptions>
    </el-drawer>
  </div>
</template>

<script>
import {bidList, checkRent,contractDetail} from "@/utils/api";
var moment = require("moment");
export default {
  components: {},
  data() {
    return {
      loading: false,
      tableData: [],
      singleCaseList: [],
      communityList: [],
      paginationData: {
        total: 0,
        pageNum: 1,
        pageSize: 10,
        projectNo: "",
        projectName: "",
        createBy: localStorage.userId,
      },
      contractPopup: false,
      contractInfo: {},
      now_id: 0,
    };
  },
  computed: {},
  mounted() {
    this.getData();
    // this.getConfig();
  },
  methods: {
    // 转租
    getReList(index, row) {
      checkRent({projectId: row.projectId}).then(res => {
        if (res.code == 200) {
          this.$router.push({
            path: "/addTransaction",
            query: {
              id: row.projectId,
              isListing: 1,
              projectType: 2
            },
          });
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })

    },
    // 查看合同
    async getContractDetail(index, row) {
      let res = await contractDetail({ projectId: row.projectId });
      if (res.data) {
        this.contractInfo = res.data
        this.contractPopup = true;
      } else {
        this.$message.warning("暂无合同信息");
      }
    },
    // 新增管理员
    addTransaction() {
      this.$router.push({
        path: "/addTransaction",
      });
    },
    // 编辑管理员
    editDetail(index, row) {
      this.$router.push({
        path: "/addTransaction",
        query: {
          id: row.id,
        },
      });
    },
    // 删除管理员
    deleteAdministrators(row) {
      this.$confirm("确认删除本条数据！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // this.templateId = row.id;
          this.deleteAdmin(row);
        })
        .catch(() => {
          return this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    async deleteAdmin(row) {
      let res = await this.$http.get("/user/delcomad", {
        token: localStorage.token,
        admin_id: row.id,
      });
      if (res.errcode == 200) {
        this.$message.success("删除成功!");
        this.paginationData.pageNum = 1;
        this.getData();
      } else {
        this.$message.error(res.errmsg);
      }
    },
    // 查看案例
    viewCase(id) {
      this.now_id = id;
      // this.getSingleCaseList();
    },
    async searchData() {
      this.paginationData.pageNum = 1;
      this.getData();
    },
    resetData() {
      this.paginationData.projectNo = "";
      this.paginationData.projectName = "";
      this.paginationData.pageNum = 1;
      this.getData();
    },
    async getData() {
      let res = await bidList(this.paginationData);
      if (res.code == 200) {
        this.loading = false;
        this.tableData = res.data.rows;
        this.paginationData.total = Number(res.data.total);
      }
    },
    async getConfig() {
      let res = await this.$http.get("/system/config", {
        token: localStorage.token,
      });
      if (res.errcode == 200) {
        this.communityList = res.data.coop;
      } else {
        this.$message.error(res.errmsg);
      }
    },
    handleCurrentChange(num) {
      this.paginationData.pageNum = num;
      this.getData();
    },
    dateFormat: function (row, column) {
      var date = row[column.property];
      if (date == undefined) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD HH:mm");
    },
    formatTime(date) {
      return moment(date).format("YYYY-MM-DD HH:mm");
    },
    async handleEdit(index, row) { },
    typeFormart(row, index) {
      for (var i = 0; i < this.communityList.length; i++) {
        if (this.communityList[i].id == row.coopid) {
          return this.communityList[i].name;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.detail_box {
  padding: 25px;
}

.cert_img {
  margin-top: 25px;

  img {
    display: block;
    width: 100%;
  }
}
</style>
